import { useState, useEffect, useCallback, useRef } from "react";
import React from "react";
import {
  Col,
  Container,
  Row,
  FormGroup,
  Input,
  Button,
  Label,
  Card,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import { useFormik } from "formik";
import * as Yup from "yup";
import { post, put, get, del } from "../../../api/axios";
import endpoints from "../../../api/endpoints";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { toast, Bounce } from "react-toastify";
import imgupload from "../../../assets/images/imageupload.svg";
import Autocomplete from "react-google-autocomplete";
import { use } from "echarts";
import debounce from "lodash.debounce";
import avatar from "../../../assets/images/nav4.svg";
import Select from "react-select";
import Icon from "./Icon";
import { ImageDrop } from "quill-image-drop-module";
import ReactQuill, { Quill } from "react-quill";
import QuillResizeImage from "quill-resize-image";
import "react-quill/dist/quill.snow.css";
import { useSelector } from "react-redux";
Quill.register("modules/resize", QuillResizeImage);
Quill.register("modules/imageDrop", ImageDrop);
const EditGyms = () => {
  document.title = "Edit Gym | Elevated - Admin Dashboard";
  const { id } = useParams();
  const { currentUser } = useSelector((state) => state.auth);
  const navigate = useNavigate();
  const location = useLocation();
  const [workingHours, setWorkingHours] = useState([
    { openTime: "", closeTime: "", workingDay: "", isFullDay: false },
  ]);
  const [showDropdown, setShowDropdown] = useState(false);
  const [mediaFiles, setMediaFiles] = useState({ files: [] });
  const [logoFiles, setLogoFiles] = useState(null);
  const [image, setImage] = useState("");
  const [apiError, setApiError] = useState("");
  const [clickCount, setClickCount] = useState(0);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [ownerSearch, setOwnerSearch] = useState([]);
  const [ownerSearchTxt, setOwnerSearchTxt] = useState("");
  const [ownerloading, setOwnerloading] = useState(false);
  const [selectedOwner, setSelectedOwner] = useState(null);
  const [selectedItem, setSelectedItem] = useState(false);
  const [gymCategory, setGymCategory] = useState([]);
  const [formError, setFormError] = useState("");
  const [logoError, setLogoError] = useState("");
  const [equipment1, setEquipment1] = useState([{ file: "", name: "" }]);
  const [amenity, setAmenity] = useState([{ image: "", name: "" }]);
  const logoFileInputRef = useRef(null);
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const toggleDropdown = () => setDropdownOpen((prevState) => !prevState);
  const handleAmenity = async () => {
    try {
      const amenityData = await get(`${endpoints.amenity}`);
      if (amenityData?.data?.success) {
        setAmenity(amenityData?.data?.data);
      }
    } catch (e) {}
  };
  const handleEquipments = async () => {
    try {
      const equipData = await get(`${endpoints.equip}?&type=default`);
      if (equipData?.data?.success) {
        setEquipment1(equipData?.data?.data);
      }
    } catch (e) {}
  };
  const fetchGymsCategories = async () => {
    try {
      const response = await get(`${endpoints.gymCategory}`);
      setGymCategory(
        Array.isArray(response.data?.data) ? response?.data?.data : []
      );
    } catch (error) {
      console.error("Error fetching gyms data:", error);
      setGymCategory([]);
    } finally {
    }
  };
  useEffect(() => {
    handleAmenity();
    handleEquipments();
    fetchGymsCategories();
  }, []);
  const gymId = location.state?.gymId;
  useEffect(() => {
    if (gymId) fetchGymDetails(gymId);
  }, [gymId]);

  const fetchGymDetails = async (gymId) => {
    try {
      const response = await get(`${endpoints.gym}/${gymId}`);
      if (response?.data) {
        const {
          gymOwner,
          name,
          description,
          phoneNumber,
          email,
          website,
          googleMap,
          location,
          otherFacilities,
          amenities,
          Equipment,
          specialInfo,
          gymTag,
          gymCategory,
          openingSchedule,
          socialInfo,
          files,
          logo,
          gymOwnerId,
        } = response.data.data;

        setSelectedOwner(gymOwner);
        const gymOwnerIds = gymOwnerId;
        const amenityIds = amenities.map((amenity) => amenity.id);
        const equipIds = Equipment.map((equip) => equip.id);
        formik.setValues({
          gymOwner: gymOwner || "",
          name: name || "",
          description: description || "",
          phoneNumber,
          email: email || "",
          website,
          location: location || "",
          otherFacilities,
          specialInfo,
          gymTag: gymTag || "",
          gymCategory: gymCategory?.id || "",
          googleMap,
          facebook: socialInfo?.facebook || "",
          instagram: socialInfo?.instagram || "",
          amenityList: amenityIds || "",
          equipList: equipIds || "",
        });

        if (
          openingSchedule &&
          Array.isArray(openingSchedule) &&
          openingSchedule.length > 0
        ) {
          setWorkingHours(openingSchedule);
        }
        // setOwnerSearchTxt(
        //   `${gymOwnerId?.firstName != null ? gymOwnerId?.firstName : ""} ${
        //     gymOwnerId?.lastName != null ? gymOwnerId?.lastName : ""
        //   }`
        // );
        setOwnerSearchTxt(gymOwnerId?.firstName);
        setAmenity(amenities);
        setEquipment1(Equipment);
        const imageFiles = files
          .filter((file) => file.type === "image")
          .map((file) => `${process.env.REACT_APP_IMG_URL}${file.data}`);

        setMediaFiles({ files: imageFiles });

        setLogoFiles(`${process.env.REACT_APP_IMG_URL}${logo.data}`);
      }
    } catch (error) {
      setApiError("Failed to fetch gym details. Please try again.");
    }
  };

  const formik = useFormik({
    initialValues: {
      name: "",
      description: "",
      phoneNumber: "",
      email: "",
      website: "",
      location: {
        formatted_address: "",
      },
      otherFacilities: "",
      specialInfo: "",
      gymOwner: undefined,
      googleMap: "",
      gymTag: [],
      gymCategory: "",
      equipment: "",
      openingSchedule: [],
      amenityList: [],
      equipList: [],
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Name is required!"),
      gymCategory: Yup.string().required("Please select the category!"),
      description: Yup.string().required("Description is required"),
      phoneNumber: Yup.string()
        .matches(
          /^\d{11}$/,
          "Phone number must be 11 digits and contain only numbers"
        )
        .required("Phone number is required"),
      email: Yup.string().email("Invalid email").required("Email is required"),
      location: Yup.object().shape({
        formatted_address: Yup.string().required("Location is required"),
      }),

      gymTag: Yup.array()
        .min(1, "At least one tag is required")
        .required("Tag is required"),
    }),
    onSubmit: async (values) => {
      try {
        if (mediaFiles.files.length <= 0) {
          setFormError("Please select atleast one media file");
          return false;
        } else {
          setFormError("");
        }
        if (!logoFiles) {
          setLogoError("Please select upload Logo file");
          return false;
        } else {
          setLogoError("");
        }

        setIsSubmitting(true);
        const formData = new FormData();
        if (
          values.gymOwner !== null &&
          values.gymOwner !== "" &&
          values.gymOwner !== undefined &&
          values.gymOwner !== "undefined"
        ) {
          console.log("i am if");
          formData.append("gymOwner", values.gymOwner);
        } else {
          console.log("i am else");
          formData.append("gymOwner", currentUser?.id);
        }

        Object.entries(values).forEach(([key, value]) => {
          if (value && key !== "gymOwner") {
            formData.append(key, value);
          }
        });

        formData.set("openingSchedule", JSON.stringify(workingHours));

        if (values.location) {
          formData.set("location", JSON.stringify(values.location));
        }

        mediaFiles.files.forEach((file) => formData.append("files", file));

        formData.append("logo", logoFiles);

        const response = await put(`${endpoints.gym}/${gymId}`, formData, {
          headers: { "Content-Type": "multipart/form-data" },
        });

        if (response?.data?.success) {
          navigate("/list-gyms");
          toast.success("Gym Updated Successfully", {
            position: "bottom-center",
            theme: "colored",
            transition: Bounce,
          });
        } else if (response?.response?.data) {
          toast.error(response?.response?.data?.message, {
            position: "bottom-center",
            theme: "colored",
            transition: Bounce,
          });
        } else {
          toast.error("Failed to update gym. Please try again.");
        }
      } catch (error) {
        console.error("Error submitting form:", error);
        toast.error("An error occurred. Please try again.");
      } finally {
        setIsSubmitting(false);
      }
    },
  });
  const handleFileChange = (e, type = "media") => {
    if (type == "logo") {
      setLogoFiles(e.target.files[0]);
    } else {
      const files = Array.from(e.target.files);

      const validFiles = files.filter(
        (file) =>
          file.type.startsWith("image/") || file.type.startsWith("video/")
      );
      setMediaFiles((prev) => ({
        files: [...prev.files, ...validFiles],
      }));
      if (mediaFiles.files.length > 0) {
        setFormError("");
      }
      e.target.value = null;
    }
  };

  const removeMedia = async (index) => {
    const fileToDelete = mediaFiles.files[index];

    if (fileToDelete instanceof File) {
      setMediaFiles((prev) => ({
        files: prev.files.filter((_, i) => i !== index),
      }));
      return;
    }

    try {
      const response = await del(
        `${endpoints.gym}/del?resourceType=gym&resourceId=${gymId}&url=${fileToDelete}`
      );

      if (response?.data?.success) {
        setMediaFiles((prev) => ({
          files: prev.files.filter((_, i) => i !== index),
        }));
      } else {
        toast.error("Failed to remove media. Please try again.");
      }
    } catch (error) {
      console.error("Error removing media:", error);
      toast.error("An error occurred while removing media.");
    }
  };

  const removeLogo = async () => {
    try {
      const response = await del(
        `${endpoints.gym}/del?resourceType=gym&resourceId=${gymId}&url=${logoFiles.data}`
      );

      if (response?.data?.success) {
        setLogoFiles();
      } else {
        toast.error("Failed to remove media. Please try again.");
      }
    } catch (error) {
      console.error("Error removing media:", error);
      toast.error("An error occurred while removing media.");
    }
  };

  const addWorkingHours = () => {
    if (clickCount < 7) {
      setWorkingHours([
        ...workingHours,
        { openTime: "", closeTime: "", workingDay: "" },
      ]);
      setClickCount(clickCount + 1);
    }
  };
  const searchGymOwner = async (search) => {
    try {
      const searchData = await get(
        `${endpoints.owner}?page=1&limit=6&search=${search}`
      );
      if (searchData?.data?.success) {
        setOwnerSearch(searchData?.data?.data);
        setOwnerloading(false);
      }
    } catch (e) {
      setOwnerloading(false);
    }
  };
  const handleInputChange = (e) => {
    setOwnerloading(true);
    setSelectedItem(true);

    const value = e.target.value;
    setOwnerSearchTxt(value);
    debouncedSearch(value);
  };
  const debouncedSearch = useCallback(
    debounce((query) => searchGymOwner(query), 500), // Adjust debounce delay as needed
    []
  );
  const selectedGymOwner = (data) => {
    setSelectedOwner(data);
    setSelectedItem(false);

    setOwnerSearchTxt(
      `${data?.firstName != null ? data?.firstName : ""} ${
        data?.lastName != null ? data?.lastName : ""
      }`
    );
  };
  const customStyles = {
    control: (provided) => ({
      ...provided,
      minHeight: "56px",
      borderRadius: "80px",
      backgroundColor: "#f8f9fa",
      border: "none",
      boxShadow: "none",
      paddingLeft: "15px",
    }),
    multiValue: (provided) => ({
      ...provided,
      backgroundColor: "rgba(59, 171, 166, 0.35)",
      borderRadius: "5px",
    }),
    menu: (provided) => ({
      ...provided,
      borderRadius: "5px",
      marginTop: "4px",
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected
        ? "rgba(59, 171, 166, 0.35)"
        : state.isFocused
        ? "#e9ecef"
        : "transparent",
      color: state.isSelected ? "#fff" : "#000",
    }),
  };

  return (
    <div className="page-conten mt-2 mb-5 ">
      <Container fluid>
        <Row>
          <Col>
            <Card className="rounded-4">
              <form className="p-4" onSubmit={formik.handleSubmit}>
                <h3 className="ff-sora font-size-20 fw-bold primary-black">
                  Edit Gym
                </h3>
                <FormGroup>
                  <Label className="ff-sora font-size-16 fw-normal secondary-black">
                    Logo <span className="text-danger">*</span>
                  </Label>
                  <div
                    className="rounded-4 bg-light d-flex flex-wrap justify-content-start align-items-center p-3"
                    style={{
                      border: "2px dashed #ccc",
                      maxWidth: "100%",
                      cursor: "pointer",
                    }}
                    // onClick={() => document.getElementById("logoInput").click()}
                  >
                    {logoFiles && (
                      <div
                        className="me-2 mb-2 position-relative"
                        style={{
                          width: "100px",
                          height: "100px",
                        }}
                      >
                        <img
                          src={
                            logoFiles instanceof File
                              ? URL.createObjectURL(logoFiles)
                              : logoFiles
                          }
                          alt={`Preview ${logoFiles}`}
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                            borderRadius: "8px",
                          }}
                        />
                        <button
                          type="button"
                          className="position-absolute top-0 end-0 text-black bg-white rounded-circle border-0 cursor-pointer d-flex justify-content-center align-items-center"
                          style={{
                            width: "20px",
                            height: "20px",
                          }}
                          onClick={(e) => {
                            e.stopPropagation();
                            removeLogo();
                          }}
                        >
                          X
                        </button>
                      </div>
                    )}

                    {logoFiles == null && (
                      <div
                        className="d-flex flex-column justify-content-center align-items-center"
                        style={{
                          width: "100px",
                          height: "100px",
                          border: "2px dashed #ccc",
                          borderRadius: "8px",
                          cursor: "pointer",
                        }}
                        onClick={() =>
                          document.getElementById("logoInput").click()
                        }
                      >
                        <img
                          src={imgupload}
                          alt="Upload"
                          height="32px"
                          width="32px"
                        />
                        <div className="text-center ff-sora font-size-16 fw-normal secondary-black">
                          Add Logo
                        </div>
                      </div>
                    )}

                    <input
                      type="file"
                      accept="image/*,video/*"
                      id="logoInput"
                      className="d-none"
                      onChange={(e) => {
                        handleFileChange(e, "logo");
                      }}
                      multiple={true}
                    />
                  </div>
                  {logoError && <div className="text-danger">{logoError}</div>}
                </FormGroup>
                <FormGroup>
                  <Label className="ff-sora font-size-16 fw-normal secondary-black">
                    Media <span className="text-danger">*</span>
                  </Label>
                  <div
                    className="rounded-4 bg-light d-flex flex-wrap justify-content-start align-items-center p-3"
                    style={{
                      border: "2px dashed #ccc",
                      maxWidth: "100%",
                      cursor: "pointer",
                    }}
                    // onClick={() => document.getElementById("fileInput").click()}
                  >
                    {mediaFiles?.files?.map((file, index) => (
                      <div
                        key={index}
                        className="me-2 mb-2 position-relative"
                        style={{
                          width: "100px",
                          height: "100px",
                        }}
                      >
                        <img
                          src={
                            file instanceof File
                              ? URL.createObjectURL(file)
                              : file
                          }
                          alt={`Preview ${index}`}
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                            borderRadius: "8px",
                          }}
                        />
                        <button
                          type="button"
                          className="position-absolute top-0 end-0 text-black bg-white rounded-circle border-0 cursor-pointer d-flex justify-content-center align-items-center"
                          style={{
                            width: "20px",
                            height: "20px",
                          }}
                          onClick={(e) => {
                            e.stopPropagation();
                            removeMedia(index);
                          }}
                        >
                          X
                        </button>
                      </div>
                    ))}

                    {/* {mediaFiles?.files?.length < 10 && ( */}
                    <div
                      className="d-flex flex-column justify-content-center align-items-center"
                      style={{
                        width: "100px",
                        height: "100px",
                        border: "2px dashed #ccc",
                        borderRadius: "8px",
                        cursor: "pointer",
                      }}
                      onClick={() =>
                        document.getElementById("fileInput").click()
                      }
                    >
                      <img
                        src={imgupload}
                        alt="Upload"
                        height="32px"
                        width="32px"
                      />
                      <div className="text-center ff-sora font-size-16 fw-normal secondary-black">
                        Add Media
                      </div>
                    </div>
                    {/* )} */}

                    <input
                      type="file"
                      accept="image/*,video/*"
                      multiple
                      id="fileInput"
                      className="d-none"
                      onChange={(e) => {
                        handleFileChange(e, "media");
                      }}
                    />
                  </div>
                  {formError && <div className="text-danger">{formError}</div>}
                </FormGroup>
                <>
                  <h5 className="ff-sora font-size-16 fw-normal secondary-black">
                    Assign Gym Owner
                  </h5>
                  <FormGroup className="position-relative">
                    <Input
                      type="text"
                      name="name"
                      style={{
                        height: "56px",
                        border: "none",
                      }}
                      placeholder="Select Gym Owner"
                      className="rounded-5 bg-light ff-sora font-size-16 fw-normal tertiary-black px-4"
                      value={ownerSearchTxt}
                      onChange={(e) => {
                        const value = e.target.value;
                        setOwnerSearchTxt(value);
                        handleInputChange(e);
                        if (value.trim() === "") {
                          setSelectedOwner(null);
                          formik.setFieldValue("gymOwner", undefined);
                        }
                      }}
                      onFocus={(e) => {
                        setOwnerSearchTxt(e.target.value);
                        handleInputChange(e);
                        setShowDropdown(true);
                      }}
                    />
                    {selectedOwner && (
                      <button
                        onClick={() => {
                          setSelectedOwner(null);
                          setOwnerSearchTxt("");
                          formik.setFieldValue("gymOwner", undefined);
                        }}
                        style={{
                          position: "absolute",
                          right: "15px",
                          top: "50%",
                          transform: "translateY(-50%)",
                          background: "transparent",
                          border: "none",
                          cursor: "pointer",
                        }}
                      >
                        ✖
                      </button>
                    )}
                    {formik.errors.gymOwner && (
                      <div className="text-danger">
                        {formik.errors.gymOwner}
                      </div>
                    )}
                  </FormGroup>

                  {/* Dropdown */}
                  {(ownerloading || (selectedItem && !ownerloading)) &&
                    showDropdown && (
                      <div
                        style={{
                          position: "relative",
                        }}
                      >
                        <ul
                          style={{
                            listStyle: "none",
                            borderRadius: "10px",
                            border: "1px solid #eaeced",
                            padding: "10px",
                            maxHeight: "200px",
                            overflowY: "auto",
                            marginTop: "8px",
                            background: "#fff",
                            boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                          }}
                        >
                          {/* Loading State */}
                          {ownerloading && ownerSearch.length <= 0 && (
                            <li className="d-flex align-items-center gymOwnerContainer">
                              <p className="text-center ff-sora fw-normal font-size-16">
                                Loading...
                              </p>
                            </li>
                          )}

                          {/* Search Results */}
                          {ownerSearch
                            .filter((item) =>
                              `${item.firstName} ${item.lastName}`
                                .toLowerCase()
                                .includes(ownerSearchTxt.toLowerCase())
                            )
                            .map((item, index) => (
                              <li
                                key={index}
                                onClick={() => {
                                  selectedGymOwner(item); // Handle selection
                                  formik.setFieldValue("gymOwner", item?.id); // Update Formik value
                                  setShowDropdown(false); // Close dropdown on selection
                                }}
                                className="d-flex align-items-center gymOwnerContainer"
                                style={{
                                  padding: "10px",
                                  borderRadius: "5px",
                                  cursor: "pointer",
                                  transition: "background-color 0.2s",
                                }}
                                onMouseEnter={(e) =>
                                  (e.currentTarget.style.backgroundColor =
                                    "#f7f7f7")
                                }
                                onMouseLeave={(e) =>
                                  (e.currentTarget.style.backgroundColor =
                                    "transparent")
                                }
                              >
                                <img
                                  className="gymOwnerImage"
                                  src={
                                    item?.additionalInfo?.profileImage
                                      ? process.env.REACT_APP_IMG_URL +
                                        item?.additionalInfo?.profileImage
                                      : avatar
                                  }
                                  alt="Gym Owner"
                                  style={{
                                    width: "40px",
                                    height: "40px",
                                    borderRadius: "50%",
                                    marginRight: "10px",
                                    objectFit: "cover",
                                  }}
                                />
                                <p className="m-0 font-size-16 tertiary-black ff-sora">
                                  {item.firstName} {item.lastName}
                                </p>
                              </li>
                            ))}

                          {/* No Results Found */}
                          {ownerSearch.filter((item) =>
                            `${item.firstName} ${item.lastName}`
                              .toLowerCase()
                              .includes(ownerSearchTxt.toLowerCase())
                          ).length === 0 && (
                            <li className="d-flex align-items-center gymOwnerContainer">
                              <p className="text-center ff-sora fw-normal font-size-16">
                                No results found.
                              </p>
                            </li>
                          )}
                        </ul>

                        {/* Close Button */}
                        <button
                          onClick={() => setShowDropdown(false)}
                          style={{
                            position: "absolute",
                            top: "5px",
                            right: "10px",
                            background: "transparent",
                            border: "none",
                            cursor: "pointer",
                            fontSize: "16px",
                            color: "#333",
                          }}
                        >
                          ✖
                        </button>
                      </div>
                    )}
                </>
                <h5 className="ff-sora font-size-16 fw-normal secondary-black">
                  Gym Info <span className="text-danger">*</span>
                </h5>
                <FormGroup>
                  <Input
                    type="text"
                    name="name"
                    placeholder="Gym/Club name"
                    className="rounded-5 bg-light ff-sora font-size-16 fw-normal tertiary-black px-4"
                    value={formik.values.name}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    style={{
                      height: "56px",
                      border: "none",
                    }}
                  />
                  {formik.touched.name && formik.errors.name ? (
                    <div className="text-danger">{formik.errors.name}</div>
                  ) : null}
                </FormGroup>
                <FormGroup>
                  <Input
                    type="textarea"
                    name="description"
                    placeholder="Description"
                    className="rounded-4 bg-light pb-5 ff-sora font-size-16 fw-normal tertiary-black px-4 border-none"
                    value={formik.values.description}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                  {formik.touched.description && formik.errors.description ? (
                    <div className="text-danger">
                      {formik.errors.description}
                    </div>
                  ) : null}
                </FormGroup>
                {/* Contact Info */}
                <h5 className="ff-sora font-size-16 fw-normal secondary-black">
                  Contact Info <span className="text-danger">*</span>
                </h5>
                <Row form>
                  <Col md={4}>
                    <FormGroup>
                      <Input
                        type="text"
                        name="phoneNumber"
                        placeholder="Contact no."
                        style={{
                          height: "56px",
                          border: "none",
                        }}
                        className="rounded-5 bg-light ff-sora font-size-16 fw-normal tertiary-black px-4"
                        value={formik.values.phoneNumber}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                      />
                      {formik.touched.phoneNumber &&
                      formik.errors.phoneNumber ? (
                        <div className="text-danger">
                          {formik.errors.phoneNumber}
                        </div>
                      ) : null}
                    </FormGroup>
                  </Col>
                  <Col md={4}>
                    <FormGroup>
                      <Input
                        type="email"
                        name="email"
                        placeholder="Email"
                        style={{
                          height: "56px",
                          border: "none",
                        }}
                        className="rounded-5 bg-light ff-sora font-size-16 fw-normal tertiary-black px-4"
                        value={formik.values.email}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                      />
                      {formik.touched.email && formik.errors.email ? (
                        <div className="text-danger">{formik.errors.email}</div>
                      ) : null}
                    </FormGroup>
                  </Col>
                  <Col md={4}>
                    <FormGroup>
                      <Input
                        type="text"
                        name="website"
                        placeholder="Website"
                        style={{
                          height: "56px",
                          border: "none",
                        }}
                        className="rounded-5 bg-light ff-sora font-size-16 fw-normal tertiary-black px-4"
                        value={formik.values.website}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                      />
                    </FormGroup>
                  </Col>
                </Row>
                <h5 className="ff-sora font-size-16 fw-normal secondary-black">
                  Location <span className="text-danger">*</span>
                </h5>{" "}
                <FormGroup>
                  <Autocomplete
                    apiKey="AIzaSyCMj0TE0Q3eOujTHxhTUhMOiLX0KVRSIGM"
                    name="location"
                    placeholder="Location"
                    style={{
                      height: "56px",
                      border: "none",
                    }}
                    className="rounded-5 bg-light ff-sora font-size-16 fw-normal tertiary-black form-control px-4"
                    onPlaceSelected={(place) => {
                      if (place && place.formatted_address) {
                        formik.setFieldValue("location", {
                          formatted_address: place.formatted_address,
                          address_components: place.address_components.map(
                            (component) => ({
                              long_name: component.long_name,
                              short_name: component.short_name,
                              types: component.types,
                            })
                          ),
                          geometry: place.geometry,
                        });
                        formik.setFieldTouched("location", true); // ✅ Mark field as touched
                      }
                    }}
                    value={formik.values.location?.formatted_address || ""}
                    onChange={(e) => {
                      formik.setFieldValue("location", {
                        formatted_address: e.target.value,
                      });
                      formik.setFieldTouched("location", true); // ✅ Also touch on manual input
                    }}
                    onBlur={() => {
                      if (!formik.values.location?.geometry) {
                        formik.setFieldValue("location", "");
                      }
                      formik.setFieldTouched("location", true); // ✅ Always mark touched
                      formik.handleBlur("location");
                    }}
                    options={{
                      types: ["address"],
                    }}
                  />

                  {formik.touched.location &&
                    formik.errors.location?.formatted_address && (
                      <div className="text-danger">
                        {formik.errors.location.formatted_address}
                      </div>
                    )}
                </FormGroup>
                <Row>
                  <Col md={4}>
                    <h5 className="ff-sora font-size-16 fw-normal secondary-black">
                      Category <span className="text-danger">*</span>
                    </h5>
                    <FormGroup>
                      <div className="position-relative">
                        <select
                          name="gymCategory"
                          style={{
                            height: "56px",
                            border: "none",
                          }}
                          className="form-select rounded-5 bg-light ff-sora font-size-16 fw-normal tertiary-black px-4"
                          value={formik.values.gymCategory}
                          onChange={(e) => {
                            formik.setFieldValue("gymCategory", e.target.value);
                          }}
                          onBlur={formik.handleBlur}
                        >
                          {formik.values.gymCategory == "" && (
                            <option value="" disabled style={{ opacity: 0 }}>
                              Select Category
                            </option>
                          )}
                          {gymCategory?.map((tag) => (
                            <option key={tag.id} value={tag.id}>
                              {tag.title}
                            </option>
                          ))}
                        </select>
                      </div>

                      {formik.touched.gymCategory &&
                      formik.errors.gymCategory ? (
                        <div className="text-danger font-size-12 ff-sora fw-normal my-1">
                          {formik.errors.gymCategory}
                        </div>
                      ) : null}
                    </FormGroup>
                  </Col>
                  <Col md={4}>
                    <h5 className="ff-sora font-size-16 fw-normal secondary-black">
                      Tags <span className="text-danger">*</span>
                    </h5>
                    <FormGroup>
                      <div className="position-relative">
                        <Input
                          type="select"
                          name="gymTag"
                          className="d-none"
                          multiple
                          value={formik.values.gymTag}
                          onChange={formik.handleChange}
                        />

                        <div
                          className="d-flex flex-wrap gap-2 align-items-center bg-light rounded-5 p-2 min-h-56"
                          style={{ minHeight: "56px" }}
                        >
                          {formik.values.gymTag?.map((tag) => (
                            <span
                              key={tag}
                              className="badge bg-brand-orange text-dark py-2 px-3 rounded-5 cursor-pointer font-size-14 fw-normal d-flex align-items-center gap-1"
                              onClick={() => {
                                formik.setFieldValue(
                                  "gymTag",
                                  formik.values.gymTag.filter((t) => t !== tag)
                                );
                              }}
                            >
                              {tag} <span>&times;</span>
                            </span>
                          ))}

                          {formik.values.gymTag?.length < 3 && (
                            <Dropdown
                              isOpen={dropdownOpen}
                              toggle={toggleDropdown}
                            >
                              <DropdownToggle
                                tag="div"
                                className="rounded-5 border-0 bg-transparent shadow-none p-2 cursor-pointer d-flex align-items-center"
                                data-toggle="dropdown"
                                aria-expanded={dropdownOpen}
                              >
                                <span className="me-1 ff-sora font-size-16 fw-normal secondary-black">
                                  + Add Tag
                                </span>
                              </DropdownToggle>
                              <DropdownMenu className="rounded-5">
                                {["NEWGYM", "NOTEWORTHY", "MOSTLOVED"]
                                  .filter(
                                    (tag) => !formik.values.gymTag.includes(tag)
                                  )
                                  .map((tag) => (
                                    <DropdownItem
                                      key={tag}
                                      onClick={() => {
                                        const newTags = [
                                          ...formik.values.gymTag,
                                          tag,
                                        ];
                                        formik.setFieldValue("gymTag", newTags);
                                      }}
                                      className="ff-sora font-size-16 fw-normal"
                                    >
                                      {tag}
                                    </DropdownItem>
                                  ))}
                              </DropdownMenu>
                            </Dropdown>
                          )}
                        </div>
                      </div>

                      {formik.touched.gymTag && formik.errors.gymTag && (
                        <div className="text-danger font-size-12 ff-sora fw-normal my-1">
                          {formik.errors.gymTag}
                        </div>
                      )}
                    </FormGroup>
                  </Col>
                  <Col md={4}>
                    <h5 className="ff-sora font-size-16 fw-normal secondary-black">
                      Google Map Link
                    </h5>
                    <FormGroup>
                      <Input
                        type="url"
                        style={{
                          height: "56px",
                          border: "none",
                        }}
                        name="googleMap"
                        placeholder="GoogleMap link"
                        className="rounded-5 bg-light ff-sora font-size-16 fw-normal tertiary-black px-4"
                        value={formik.values.googleMap}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                      />
                      {formik.touched.googleMap && formik.errors.googleMap ? (
                        <div className="text-danger">
                          {formik.errors.googleMap}
                        </div>
                      ) : null}
                    </FormGroup>
                  </Col>
                  <Col md={6}>
                    <h5 className="ff-sora font-size-16 fw-normal secondary-black">
                      Facebook
                    </h5>
                    <FormGroup>
                      <Input
                        type="facebook"
                        style={{
                          height: "56px",
                          border: "none",
                        }}
                        name="facebook"
                        placeholder="Facebook link"
                        className="rounded-5 bg-light ff-sora font-size-16 fw-normal tertiary-black px-4"
                        value={formik.values.facebook}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                      />
                      {formik.touched.facebook && formik.errors.facebook ? (
                        <div className="text-danger">
                          {formik.errors.facebook}
                        </div>
                      ) : null}
                    </FormGroup>
                  </Col>

                  <Col md={6}>
                    <h5 className="ff-sora font-size-16 fw-normal secondary-black">
                      Instagram
                    </h5>
                    <FormGroup>
                      <Input
                        type="instagram"
                        style={{
                          height: "56px",
                          border: "none",
                        }}
                        name="instagram"
                        placeholder="Instagram link"
                        className="rounded-5 bg-light ff-sora font-size-16 fw-normal tertiary-black px-4"
                        value={formik.values.instagram}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                      />
                      {formik.touched.instagram && formik.errors.instagram ? (
                        <div className="text-danger">
                          {formik.errors.instagram}
                        </div>
                      ) : null}
                    </FormGroup>
                  </Col>
                </Row>
                <h5 className="ff-sora font-size-16 fw-normal secondary-black">
                  Working Hours
                </h5>
                {workingHours.map((obj, index) => (
                  <Row
                    form
                    key={index}
                    className="d-flex align-items-center mb-3"
                  >
                    <Col md={2}>
                      <FormGroup>
                        <Input
                          type="select"
                          style={{
                            height: "56px",
                            border: "none",
                          }}
                          className="rounded-5 bg-light ff-sora font-size-16 fw-normal tertiary-black px-4"
                          value={obj.workingDay}
                          onChange={(e) => {
                            const newHours = [...workingHours];
                            newHours[index].workingDay = e.target.value;
                            setWorkingHours(newHours);
                          }}
                        >
                          <option>Select day</option>
                          <option>Monday</option>
                          <option>Tuesday</option>
                          <option>Wednesday</option>
                          <option>Thursday</option>
                          <option>Friday</option>
                          <option>Saturday</option>
                          <option>Sunday</option>
                        </Input>
                      </FormGroup>
                    </Col>
                    <Col md={2}>
                      <FormGroup>
                        <Input
                          type="time"
                          value={obj.isFullDay ? "00:00" : obj.openTime}
                          disabled={obj.isFullDay}
                          style={{
                            height: "56px",
                            border: "none",
                          }}
                          className="rounded-5 bg-light ff-sora font-size-16 fw-normal tertiary-black px-4"
                          placeholder="Start time"
                          onChange={(e) => {
                            const newHours = [...workingHours];
                            newHours[index].openTime = e.target.value;
                            setWorkingHours(newHours);
                          }}
                        />
                      </FormGroup>
                    </Col>
                    <Col md={2}>
                      <FormGroup>
                        <Input
                          type="time"
                          value={obj.isFullDay ? "00:00" : obj.closeTime}
                          disabled={obj.isFullDay}
                          style={{
                            height: "56px",
                            border: "none",
                          }}
                          className="rounded-5 bg-light ff-sora font-size-16 fw-normal tertiary-black px-4"
                          placeholder="Close Time"
                          onChange={(e) => {
                            const newHours = [...workingHours];
                            newHours[index].closeTime = e.target.value;
                            setWorkingHours(newHours);
                          }}
                        />
                      </FormGroup>
                    </Col>
                    <Col md={3}>
                      <FormGroup className="d-flex align-items-center">
                        <Label
                          check
                          className="d-flex align-items-center ff-sora font-size-16 fw-normal secondary-black"
                        >
                          <Input
                            type="checkbox"
                            checked={obj.isFullDay}
                            onChange={(e) => {
                              const newHours = [...workingHours];
                              newHours[index] = {
                                ...newHours[index],
                                isFullDay: e.target.checked,
                                openTime: e.target.checked ? "00:00" : "",
                                closeTime: e.target.checked ? "00:00" : "",
                              };
                              setWorkingHours(newHours);
                            }}
                            className="mx-3"
                            style={{
                              border: "1px solid black",
                              height: "25px",
                              width: "25px",
                            }}
                          />
                          Open 24-Hours
                        </Label>
                      </FormGroup>
                    </Col>
                    <Col
                      md={3}
                      className="d-flex justify-content-between mb-3 flex-md-column flex-xxl-row"
                    >
                      <a
                        className="rounded-pill1 text-sub-black fw-normal font-size-16 ff-sora cursor-pointer pt-2"
                        onClick={addWorkingHours}
                        disabled={clickCount >= 6}
                        style={{
                          display: clickCount >= 6 ? "none" : "inline-block",
                        }}
                      >
                        +Add Hour
                      </a>
                      <a
                        className="rounded-pill1 text-sub-black fw-normal font-size-16 ff-sora cursor-pointer mt-md-2 mt-xxl-0 ms-xl-1 pt-2"
                        onClick={() => {
                          if (workingHours.length === 1) {
                            const updatedHours = [
                              {
                                openTime: "",
                                closeTime: "",
                                workingDay: "",
                                isFullDay: false,
                              },
                            ];
                            setWorkingHours(updatedHours);
                          } else {
                            const updatedHours = workingHours.filter(
                              (_, i) => i !== index
                            );
                            setWorkingHours(updatedHours);
                            setClickCount(clickCount - 1);
                          }
                        }}
                      >
                        Remove
                      </a>
                    </Col>
                  </Row>
                ))}
                <h5 className="ff-sora font-size-16 fw-normal secondary-black">
                  Amenities
                </h5>
                <FormGroup>
                  <Select
                    name="amenitiesList"
                    options={amenity}
                    styles={customStyles}
                    value={amenity.filter((option) =>
                      formik.values.amenityList.includes(option.id)
                    )}
                    onFocus={handleAmenity}
                    onChange={(selectedOptions) => {
                      const selectedValues = selectedOptions
                        ? selectedOptions.map((option) => option.id)
                        : [];
                      formik.setFieldValue("amenityList", selectedValues);
                    }}
                    onBlur={formik.handleBlur}
                    isMulti
                    getOptionLabel={(e) => (
                      <div className="d-flex align-items-center">
                        <img
                          src={
                            e.image == null
                              ? avatar
                              : `${process.env.REACT_APP_IMG_URL}${e.image}`
                          }
                          alt={e.name}
                          style={{
                            width: 30,
                            height: 30,
                            marginRight: 10,
                          }}
                        />
                        <span className="ff-sora font-size-16 fw-normal">
                          {e.name}
                        </span>
                      </div>
                    )}
                    getOptionValue={(e) => e.id}
                    className="rounded-5 bg-light ff-sora font-size-16 fw-normal tertiary-black "
                    placeholder="Select Amenity"
                  />
                </FormGroup>
                <h5 className="ff-sora font-size-16 fw-normal secondary-black">
                  Add Equipments
                </h5>
                <FormGroup>
                  <Select
                    name="gymEquipmentsList"
                    options={equipment1}
                    styles={customStyles}
                    value={equipment1.filter((option) =>
                      formik.values.equipList.includes(option.id)
                    )}
                    onFocus={handleEquipments}
                    onChange={(selectedOptions) => {
                      const selectedValues = selectedOptions
                        ? selectedOptions.map((option) => option.id)
                        : [];
                      formik.setFieldValue("equipList", selectedValues);
                    }}
                    onBlur={formik.handleBlur}
                    isMulti
                    getOptionLabel={(e) => (
                      <div className="d-flex align-items-center">
                        <img
                          src={
                            e.file == null
                              ? avatar
                              : `${process.env.REACT_APP_IMG_URL}${e.file}`
                          }
                          alt={e.name}
                          style={{
                            width: 30,
                            height: 30,
                            marginRight: 10,
                          }}
                        />
                        <span className="ff-sora font-size-16 fw-normal">
                          {e.name}
                        </span>
                      </div>
                    )}
                    getOptionValue={(e) => e.id}
                    className="rounded-5 bg-light ff-sora font-size-16 fw-normal tertiary-black "
                    placeholder="Select Equipments"
                  />
                </FormGroup>
                <h5 className="ff-sora font-size-16 fw-normal secondary-black">
                  Special Info
                </h5>
                <FormGroup>
                  <ReactQuill
                    value={formik.values.specialInfo?.toString() || ""}
                    name="specialInfo"
                    placeholder="Special Info"
                    onChange={(state) =>
                      formik.setFieldValue("specialInfo", state)
                    }
                    onBlur={() => formik.setFieldTouched("specialInfo", true)}
                    theme="snow"
                    modules={{
                      toolbar: [
                        [{ header: [1, 2, false] }],
                        [{ font: [] }],
                        [{ list: "ordered" }, { list: "bullet" }],
                        ["bold", "italic", "underline", "strike"],
                        [{ color: [] }, { background: [] }],
                        [{ align: [] }],
                        ["link", "image"],
                        ["clean"],
                      ],
                      imageDrop: true,
                      resize: { locale: {} },
                      clipboard: true, // Enable clipboard module
                    }}
                    formats={[
                      "header",
                      "font",
                      "list",
                      "bold",
                      "italic",
                      "underline",
                      "strike",
                      "color",
                      "background",
                      "align",
                      "link",
                      "image",
                    ]}
                    className="rounded-4 bg-light pb-5 ff-sora border-none font-size-16 fw-normal tertiary-black px-4 custom-editor"
                  />
                  {formik.errors?.specialInfo &&
                    formik.touched?.specialInfo && (
                      <div className="text-danger font-size-12 ff-sora fw-normal my-1">
                        {formik.errors.specialInfo}
                      </div>
                    )}
                </FormGroup>
                {/* <FormGroup>
                  <Input
                    type="textarea"
                    name="specialInfo"
                    placeholder="Special Info"
                    className="rounded-4 bg-light pb-5 ff-sora border-none font-size-16 fw-normal tertiary-black px-4"
                    value={formik.values.specialInfo}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                </FormGroup> */}
                <div className="d-flex float-end">
                  <Button
                    type="submit"
                    className="me-2 rounded-pill"
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? (
                      <span
                        className="spinner-border spinner-border-sm"
                        role="status"
                        aria-hidden="true"
                      ></span>
                    ) : (
                      "Update Gym"
                    )}
                  </Button>
                  <Button
                    color="white"
                    className="rounded-pill1"
                    onClick={() => navigate("/list-gyms")}
                  >
                    Cancel
                  </Button>
                </div>
              </form>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default EditGyms;
